module.exports = __webpack_public_path__ + "img/zone2.91a40d2a.png";